export const setSessionCookie = (sessionId: string, expiresInDays: number = 7): void => {
  const expires = new Date();
  expires.setTime(expires.getTime() + expiresInDays * 24 * 60 * 60 * 1000);

  document.cookie = `sessionId=${sessionId}; expires=${expires.toUTCString()}; path=/; SameSite=Strict`;
};

export const getSessionCookie = (): string | null => {
  const nameEQ = 'sessionId=';
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};

export const removeSessionCookie = (): void => {
  document.cookie = 'sessionId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};
